import { render, staticRenderFns } from "./ShipmentMain.vue?vue&type=template&id=edad44f2"
import script from "./ShipmentMain.vue?vue&type=script&lang=js"
export * from "./ShipmentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports